export default {
  init() {
    // JavaScript to be fired on the about page
    $(document).ready(function(){
      $('.different-slider').slick({
        dots: true,
        arrows: false,
        infinite: true,
        autoplay: true,
        adaptiveHeight: false,
        speed: 3000,
        slidesToShow: 1,
      });
    });
  },
  finalize() {
    // JavaScript to be fired on the services page, after the init JS
  },
};
